/**
 * 將數字轉換為 Base64 URL 安全格式的字串
 * @param num - 要轉換的數字
 * @returns - Base64 URL 安全格式的字串
 */
export function numberToBase64Url(num: number): string {
  return btoa(num.toString()).replace(/\+/g, '-').replace(/\//g, '_').replace(/=+$/, '');
}

/**
 * 將 Base64 URL 安全格式的字串轉換回數字
 * @param str - Base64 URL 安全格式的字串
 * @returns - 轉換回的數字
 */
export function base64UrlToNumber(str: string): number {
  const base64 = str.replace(/-/g, '+').replace(/_/g, '/');
  return Number(atob(base64));
}

function padBase64(base64: string): string {
  const mod = base64.length % 4;
  if (mod === 0) return base64;
  return base64 + '='.repeat(4 - mod);
}

function bytesToBase64(bytes: Uint8Array): string {
  // btoa 只能吃 Latin1；先把 bytes 轉成 binary string
  let binary = '';
  const chunkSize = 0x8000;
  for (let i = 0; i < bytes.length; i += chunkSize) {
    const chunk = bytes.subarray(i, i + chunkSize);
    binary += String.fromCharCode(...chunk);
  }
  return btoa(binary);
}

function base64ToBytes(base64: string): Uint8Array {
  const binary = atob(base64);
  const bytes = new Uint8Array(binary.length);
  for (let i = 0; i < binary.length; i += 1) {
    bytes[i] = binary.charCodeAt(i);
  }
  return bytes;
}

/**
 * 將文字轉換為 Base64 URL 安全格式的字串
 * @param str - 要轉換的文字
 * @returns - Base64 URL 安全格式的字串
 */
export function textToBase64Url(str: string): string {
  const bytes = new TextEncoder().encode(str);
  return bytesToBase64(bytes).replace(/\+/g, '-').replace(/\//g, '_').replace(/=+$/, '');
}

/**
 * 將 Base64 URL 安全格式的字串轉換回文字
 * @param str - Base64 URL 安全格式的字串
 * @returns - 轉換回的文字
 */
export function base64UrlToText(str: string): string {
  const base64 = padBase64(str.replace(/-/g, '+').replace(/_/g, '/'));
  const bytes = base64ToBytes(base64);
  return new TextDecoder().decode(bytes);
}
